const getCurrentLocale = () => localStorage.getItem('locale');

const setCurrentLocale = (locale: string) => {
  localStorage.setItem('locale', locale);
};

export default () => ({
  getCurrentLocale,
  setCurrentLocale,
});
